import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { Button } from "@covertree/ui";
import { Modal } from "@covertree/ui";
import { useMarkRenewalAsUnpaid } from "./useMarkRenewalAsUnpaid";

interface MarkRenewalAdPaidModalProps {
  open: boolean;
  onClose: () => void;
  renewalLocator: string;
}
export function MarkRenewalAsUnpaidModal({
  open,
  onClose,
  renewalLocator,
}: MarkRenewalAdPaidModalProps) {
  const { handleSubmit, loading } = useMarkRenewalAsUnpaid(
    renewalLocator,
    onClose
  );
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Are you sure?"
      disableClose={loading}
      maxWidth="md">
      <Typography variant="subtitle1" fontSize={20}>
        Do you want to mark Mortgage Bill Renewal as Unpaid?
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button
          loading={loading}
          disabled={loading}
          type="submit"
          onClick={handleSubmit}>
          Confirm
        </Button>
        <Button disabled={loading} onClick={onClose} variant="outlined">
          Cancel
        </Button>
      </Box>
    </Modal>
  );
}
